import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import React from 'react'

const DuplicateNameModal = ({ open, name, onSave, onClose }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>Duplicate Name Detected</DialogTitle>
      <DialogContent>
        It appears that an account named {name} already exists. Would you still
        like to create this account?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant='contained' onClick={onSave}>
          Create
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicateNameModal
